import { FileSourceEnum as e } from "./index74.mjs";
import { FileTypeEnum as o } from "./index75.mjs";
const n = {
  name: "systeme.io",
  colors: {
    oldBrandPrimary: "#00A0FF",
    oldTextPrimary: "#142D63",
    oldBackgroundPrimary: "#F1F4F8",
    oldBackgroundHeader: "#142D63"
  },
  favicon: {
    id: 0,
    name: "Favicon",
    filename: "Favicon",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.ico",
    thumbnail: null,
    source: e.WhiteLabel,
    size: 0,
    type: o.Image,
    createdAt: ""
  },
  logo: {
    id: 0,
    name: "Logo",
    filename: "Logo",
    path: "https://d2543nuuc0wvdg.cloudfront.net/images/logo-compact-new.svg",
    thumbnail: null,
    source: e.WhiteLabel,
    size: 0,
    type: o.Image,
    createdAt: ""
  },
  dashboardHostname: ""
};
export {
  n as defaultBrandSettings
};
